/**
 * responsible for get the current user and current roles and schemas
 */
class PublicRoutesPresenter {
  constructor(view, getSchemaUseCase) {
    this.view = view;
    this.getSchemaUseCase = getSchemaUseCase;
  }

  componentDidMount() {
    this.init();
  }

  async init() {
    this.view.showProgress();
    try {
      await this.getSchema();
      this.view.hideProgress();
    } catch (error) {
      this.view.hideProgress();
    }
  }

  async getSchema() {
    try {
      const schemas = await this.getSchemaUseCase.execute();
      this.view.setSchemas(schemas);
    } catch (error) {
      throw error;
    }
  }
}

export default PublicRoutesPresenter;
